export const ADMIN_ROLE = { id: '1', name: 'admin' } as const;
export const TEAM_MEMBER_ROLE = { id: '2', name: 'team_member' } as const;
export const FULL_READ_ROLE = { id: '3', name: 'full_read' } as const;
export const LIMITED_READ_ROLE = { id: '4', name: 'limited_read' } as const;
export const USER_COORDINATOR_ROLE = { id: '10', name: 'user_coordinator' } as const;
export const AGENCY_ADMIN_ROLE = { id: '101', name: 'agency_admin' } as const;
export const AGENCY_TEAM_MEMBER_ROLE = { id: '102', name: 'agency_team_member' } as const;
export const NO_ACCESS_ROLE = { id: '200', name: 'no_access' } as const;
export const BRANCH_ACCOUNT_ADMIN_ROLE = { id: '301', name: 'admin' } as const;

export const CUSTOM_ACCESS_ROLE_ID = '5' as const;

export const ACCESS_ROLE_ID_MAP = {
  [ADMIN_ROLE.id]: ADMIN_ROLE.name,
  [TEAM_MEMBER_ROLE.id]: TEAM_MEMBER_ROLE.name,
  [FULL_READ_ROLE.id]: FULL_READ_ROLE.name,
  [LIMITED_READ_ROLE.id]: LIMITED_READ_ROLE.name,
  [USER_COORDINATOR_ROLE.id]: USER_COORDINATOR_ROLE.name,
  [AGENCY_ADMIN_ROLE.id]: AGENCY_ADMIN_ROLE.name,
  [AGENCY_TEAM_MEMBER_ROLE.id]: AGENCY_TEAM_MEMBER_ROLE.name,
  [NO_ACCESS_ROLE.id]: NO_ACCESS_ROLE.name,
};

export const ACCESS_ROLE_NAME_MAP = {
  [ADMIN_ROLE.name]: ADMIN_ROLE.id,
  [TEAM_MEMBER_ROLE.name]: TEAM_MEMBER_ROLE.id,
  [FULL_READ_ROLE.name]: FULL_READ_ROLE.id,
  [LIMITED_READ_ROLE.name]: LIMITED_READ_ROLE.id,
  [USER_COORDINATOR_ROLE.name]: USER_COORDINATOR_ROLE.id,
  [AGENCY_ADMIN_ROLE.name]: AGENCY_ADMIN_ROLE.id,
  [AGENCY_TEAM_MEMBER_ROLE.name]: AGENCY_TEAM_MEMBER_ROLE.id,
  [NO_ACCESS_ROLE.name]: NO_ACCESS_ROLE.id,
};

export const ACCESS_ROLE_IDS = [
  ADMIN_ROLE.id,
  TEAM_MEMBER_ROLE.id,
  FULL_READ_ROLE.id,
  LIMITED_READ_ROLE.id,
  USER_COORDINATOR_ROLE.id,
  AGENCY_ADMIN_ROLE.id,
  AGENCY_TEAM_MEMBER_ROLE.id,
  NO_ACCESS_ROLE.id,
];

export const BRANCH_DEFINED_ROLE_ID_THREASHOLD = 1000;
